import axios from "axios";
import toast from "react-hot-toast";

/**
 * Sets up Axios interceptors for error handling
 */
export const setupAxiosInterceptors = () => {
    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error.response && error.response.status === 417) {
                const reloadCount = Number(sessionStorage.getItem("reloadCount")) || 0;
                if (reloadCount < 3) {
                    sessionStorage.setItem("reloadCount", String(reloadCount + 1));
                    window.location.reload();
                } else {
                    toast.error(
                        "There is an issue with loading the page. We are working on it. Please try again later."
                    );
                    sessionStorage.removeItem("reloadCount");
                }
            }
            return Promise.reject(error);
        }
    );
};
